import classNames from "classnames"
import { Link } from "react-router-dom"
import { MenuItemType } from "../menu"

export type SubMenus = {
  item: MenuItemType
  linkClassName?: string
  subMenuClassNames?: string
  activeMenuItems?: Array<string>
  toggleMenu?: (item: MenuItemType, status: boolean) => void
  className?: string
}

const MenuItemLink = ({ item, className }: SubMenus) => {
  return (
    <Link
      to={{ pathname: item.url }}
      target={item.target}
      className={classNames(
        "z-50",
        "side-nav-link-ref",
        "side-sub-nav-link",
        className
      )}
      onClick={item.onClick}
      data-menu-key={item.key}
    >
      {item.icon && <i className={item.icon}></i>}
      {item.badge && (
        <span
          className={classNames(
            "badge",
            "bg-" + item.badge.variant,
            "rounded",
            "font-10",
            "float-end",
            {
              "text-dark": item.badge.variant === "light",
              "text-light":
                item.badge.variant === "dark" ||
                item.badge.variant === "secondary",
            }
          )}
        >
          {item.badge.text}
        </span>
      )}
      <span> {item.label} </span>
    </Link>
  )
}

export default MenuItemLink
